import { createStore } from "vuex";
import common from "./modules/common";
import session from "./modules/session";
import experience from "./modules/experience";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    common,
    session,
    experience
  },
});
